// 正文 h2/h3 锚点 + 移动端目录。
//
// id 只在这里、按浏览器解析后的 DOM 决定，Liquid 不再改写正文：
// 在 Liquid 里用字符串猜"有没有 id 属性"挡不住合法 HTML 的各种写法（属性前换行、id = "x"、
// class 里恰好含同名字符串……），猜错就会覆盖作者原有的锚点。DOM 里 el.id 是确定的。
//
// 规则：已有 id 一律保留；没有的补 article-sec-N / article-sub-N（N = 正文中同级标题序号，空标题也计数），
// 与页面上任何已存在的 id 冲突时追加 -2、-3…，保证唯一。
// 目录（本文件的移动端目录、article-nav.js 的桌面目录）都按 data-heading-index 序号直接取标题元素，
// 跳转不依赖 id，所以作者自己写了重复 id 也不会跳错。
(function () {
  var rte = document.querySelector('.article-template__content-rte');
  if (!rte) return;

  function ensureIds(tag, prefix) {
    var list = rte.querySelectorAll(tag);
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.id.trim()) continue;
      var base = prefix + (i + 1);
      var id = base;
      var n = 2;
      while (document.getElementById(id)) id = base + '-' + n++;
      el.id = id;
    }
    return list;
  }

  var h2s = ensureIds('h2', 'article-sec-');
  ensureIds('h3', 'article-sub-');

  document.querySelectorAll('.article-toc-mobile__list a[data-heading-index]').forEach(function (link) {
    var heading = h2s[parseInt(link.getAttribute('data-heading-index'), 10) - 1];
    if (!heading) return;
    link.setAttribute('href', '#' + heading.id);
    link.addEventListener('click', function (event) {
      event.preventDefault();
      heading.scrollIntoView({ block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + heading.id);
    });
  });

  // 分享出去的 #article-sec-N 是这里补的 id，浏览器首屏定位时它还不存在，补完后手动定位一次
  if (location.hash.length > 1) {
    var target = null;
    try {
      target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    } catch (e) {}
    if (target && rte.contains(target)) target.scrollIntoView({ block: 'start' });
  }
})();
